"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInstance = exports.setInstance = exports.createInstance = exports.getBaseURL = void 0;
var index_1 = require("../index");
var axios_1 = require("axios");
var axios_oauth_1 = require("axios-oauth");
function getBaseURL() {
    return (0, index_1.getConfig)().baseURL;
}
exports.getBaseURL = getBaseURL;
function createInstance(config) {
    var _a;
    var newInstance = axios_1.default.create({
        baseURL: (_a = config === null || config === void 0 ? void 0 : config.baseURL) !== null && _a !== void 0 ? _a : "",
    });
    if (config === null || config === void 0 ? void 0 : config.getAuthData) {
        var lastNetworkRequest_1 = new Date();
        var oauthInterceptor = (0, axios_oauth_1.createInterceptor)({
            getAuthData: function () {
                // TODO: remove last network request checks whenever backend implements expire/refresh
                if (config === null || config === void 0 ? void 0 : config.getAuthData) {
                    var oldLastNetworkRequest = lastNetworkRequest_1;
                    lastNetworkRequest_1 = new Date();
                    return config === null || config === void 0 ? void 0 : config.getAuthData(oldLastNetworkRequest);
                }
                return Promise.resolve({
                    accessToken: null,
                    expireDate: null,
                    refreshToken: null,
                });
            },
            getRefreshConfig: function (refreshToken) { return ({
                // TODO: We don't know what this endpoint will look like yet
                // This should be implemented within core
                method: "POST",
                url: "/auth/refresh",
                data: {
                    grantType: "refresh_token",
                    refreshToken: refreshToken,
                },
            }); },
            onSignIn: function (response) {
                var setAuthData = (0, index_1.getConfig)().setAuthData;
                if (setAuthData) {
                    setAuthData({
                        accessToken: response.data.accessToken,
                        expireDate: response.data.expireDate,
                        refreshToken: response.data.refreshToken,
                    });
                }
            },
            onSignOut: function () {
                var onSignOut = (0, index_1.getConfig)().onSignOut;
                if (onSignOut) {
                    onSignOut();
                }
            },
        });
        newInstance.interceptors.request.use(oauthInterceptor.request);
        newInstance.interceptors.response.use(undefined, oauthInterceptor.failure);
    }
    newInstance.interceptors.request.use(function (axiosConfig) {
        if ((config === null || config === void 0 ? void 0 : config.getLanguage) && axiosConfig.headers) {
            var language = config === null || config === void 0 ? void 0 : config.getLanguage();
            if (language) {
                axiosConfig.headers["Accept-Language"] = language;
            }
        }
        return axiosConfig;
    }, function (error) { return Promise.reject(error); });
    return newInstance;
}
exports.createInstance = createInstance;
var instance = createInstance();
function setInstance(newInstance) {
    instance = newInstance;
}
exports.setInstance = setInstance;
function getInstance() {
    return instance;
}
exports.getInstance = getInstance;
